import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import Logo from "../logo.png";
// import Profile from "../../../images/profil.png";
// import BG from "../bg__img.jpg"

// Create styles
const styles = StyleSheet.create({
  page: {
    fontSize: "12px",
    fontFamily: "Helvetica",
  },
  badgeContainer: {
    width: 321,
    height: 204,
    paddingRight: "20px",
  },
  logoContainer: {
    marginBottom: "3px",
    textAlign: "center",
    flexDirection: "row",
    justifyContent: "center",
  },
  logoImage: {
    height: 40
  },
  title: {
    textAlign: "center",
    fontSize: "15px",
    fontFamily: "Helvetica-Bold",
    padding: "0 5px",
    marginBottom: "3px"
  },
  subtitle: {
    textAlign: "center",
    fontSize: "10px",
    marginBottom: "12px"
  },
  bodyContainer: {
    flexDirection: "row",
  },
  profileImageWrapper: {
    width: "40%",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  },
  profileImageContainer: {
    width: "80px",
    height: "80px",
    borderWidth: 3,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff"
  },
  profileName: {
    fontSize: "16px",
    marginBottom: "5px",
    textTransform: "uppercase",
  },
  profileCompany: {
    marginBottom: "3px",
    paddingRight: "20px",
    textTransform: "uppercase",
    width: "80%",
  },
  profileCompanyName: {
    marginBottom: "3px",
    textTransform: "uppercase",
    paddingRight: "20px",
    width: "75%"
  },
  backgroundBGContainer: {
    position: "absolute",
    top: "25px",
    left: "0",
    width: 320,
    height: "90%"
  },
  profileDetails: {
    paddingTop: "5px",
  }
});

// Create Document Component
const IdBadgePDF = ({ name, qrcode, position, company}) => {
  const logoUrl = "http://petros-global.com/uploads/logo/logo.png";
  const backgroundUrl = "http://petros-global.com/uploads/logo/download.png";
  return (
    <Document>
      <Page size={{
        width: 321,
        height: 204,
      }} style={styles.page}>
        <View style={styles.badgeContainer}>
          <View style={styles.backgroundBGContainer}>
            <Image src={backgroundUrl} />
          </View>
          <View style={styles.logoContainer}>
            <Image src={logoUrl} style={styles.logoImage} />
          </View>
          <View style={styles.title}>
            <Text>6th OSHE National Convention</Text>
            <Text>and General Assembly</Text>
          </View>
          <View style={styles.subtitle}>
            <Text>October 16 - 18, 2024 - Davao City</Text>
          </View>
    
          <View style={styles.bodyContainer}>
            <View style={styles.profileImageWrapper}>
              <View style={styles.profileImageContainer}>
                <Image style={styles.profileImage} src={qrcode} />
              </View>
            </View>
    
            <View style={styles.profileDetails}>
              <View style={styles.profileName}>
                <Text>{name}</Text>
              </View>
              <View style={styles.profileCompany}>
                <Text>{position}</Text>
              </View>
              <View style={styles.profileCompanyName}>
                <Text>{company}</Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default IdBadgePDF;